import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';

const Query = () => {
    const resultQuery = useStaticQuery(
        graphql`
            query {
                allContentfulPequeninArticulos {
                    nodes {
                        node_locale
                        slug
                        contentful_id
                        etapas {
                            slug
                            nombreDeLaCategoria
                        }
                        tipoDeArticulo {
                            nombreDeLaCategoria
                        }
                        categoriasDelArticulo {
                            nombreDeLaCategoria
                        }
                        nombreArticulo
                        imagenPrevisualizacionArticuloParrilla{
                            gatsbyImageData(formats: [AUTO, WEBP], placeholder: BLURRED)
                            description
                        }
                        fechaDePublicacionDelArticulo
                    }
                }
            } 
        
        `
    )
    return (resultQuery)
}

export default Query